import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';

// Interface
import { Menu } from '../../../../../utils/models/layout.interface';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { SidenavMenuComponent } from '../sidenav-menu/sidenav-menu.component';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  imports: [
      CommonModule,
      SharedModule,
      SidenavMenuComponent
    ],
  standalone: true
})
export class SidenavComponent implements OnChanges {

  @Input() menus: Menu[];
  @Output() linkClose: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() collapse;
  myCollapse = false;

  handleClick(event: boolean): void {
    this.linkClose.emit(event);
  }

  ngOnChanges(change) {
    if (change.collapse) {
      this.myCollapse = this.collapse;
    }
  }

}
